export class CurrentLocation
{
    public count:number;
    public url:string;
}